import { RegistrationReferenceType } from "../../types/commonTypes/registrationReferenceType";

export const registrationReferenceInitialState: RegistrationReferenceType = {
    acteDate: "",
    registrationDate: "",
    mortgage: ""
}